<template>
  <ul>
    <v-row>
      <v-col>
        <!--If logged in-->
        <template v-if="isLoggedIn">
          <!--Normal-->
          <v-row v-if="$vuetify.breakpoint.smAndUp" class="pt-6">
            <v-col class="ma-0 pa-0"><Notification></Notification></v-col>
            <v-col class="ma-0 pa-0"><ProfileSelection></ProfileSelection></v-col>
          </v-row>
          <!--Phone-->
          <div v-else class="pt-4">
            <v-row class="ma-0 pa-0">
              <v-col class="ma-0 pa-0"><Notification></Notification></v-col>
              <v-col class="ma-0 pa-0 pr-6"><SidebarRight></SidebarRight></v-col>
            </v-row>
          </div>
        </template>
        <!--If not logged in-->
        <template v-else>
          <!--Normal-->
          <div v-if="$vuetify.breakpoint.smAndUp">
            <v-row class="mt-10">
              <v-col class="ma-0 pa-0"><v-btn text to="/login">{{$t('navbar.general.Login')}}</v-btn></v-col>
              <v-col class="ma-0 pa-0"><span>/</span></v-col>
              <v-col class="ma-0 pa-0"><v-btn text to="/register">{{$t('navbar.general.Sign up')}}</v-btn></v-col>
              <!-- <v-col class="ma-0 pa-0"><LanguageSelector></LanguageSelector></v-col> -->
            </v-row>
          </div>
          <!--Phone-->
          <div v-else class="pt-4">
            <v-row>
              <!-- <v-col class="ma-0 pa-0"><LanguageSelector></LanguageSelector></v-col> -->
              <v-col class="ma-0 pa-0 pr-6"> <SidebarRight></SidebarRight></v-col>
            </v-row>
          </div>
        </template>
      </v-col>
    </v-row>
  </ul>
</template>

<script>
// Function imported from vuex
import { mapGetters, mapActions } from "vuex";
// i18n imported
import messages from "../../modules/lang/export";
// Flag pack - Needed here (got lang component)?
import "@/assets/flag-icon.css";
// Component imports
import Notification from "@/components/navbar/components/notification.vue";
import ProfileSelection from "@/components/navbar/components/profile_selection.vue";
import LanguageSelector from "@/components/navbar/components/language_selector.vue";
import SidebarRight from "@/components/navbar/sidebarRight.vue";
export default {
  // i18n used
  i18n: { messages },
  components: {
    Notification,
    ProfileSelection,
    LanguageSelector,
    SidebarRight
  },
  data() {
    return {
      //
    };
  },
  watch: {
    getLang(newLocale) {
      this.selectedlanguage = newLocale;
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn", "fullName", "updateStatus", "getLang"])
  }
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  width: 100%;
  margin: 0;
  padding: 0;
}
li {
  display: block;
  flex: 0 1 auto; /* Default */
  list-style-type: none;
}

li:last-child {
  margin-right: 0;
}
li a {
  text-decoration: none;
  color: inherit;
}
</style>


